import Immutable from "immutable";
import { useFormikContext } from "formik";
const useSearchFiltersFormState = () => {
  const {
    values: { searchFilters = Immutable.OrderedMap() }
  } = useFormikContext();
  return searchFilters;
};
export default useSearchFiltersFormState;
